import React, { useState } from 'react';

export const useToggleMore = ({
  items = [], limit, showMoreText = 'Show more', showLessText = 'Show less',
}) => {
  const shouldUseToogle = items.length > limit;
  const [shouldShowCollapsedList, setShouldShowCollapsedList] = useState(shouldUseToogle);

  const onToggleLimitClick = () => (
    setShouldShowCollapsedList((shouldShowCollapsedList) => (!shouldShowCollapsedList))
  );

  const renderShowMoreButton = () => (
    shouldUseToogle ?
      <button className="mn_moreOrLessButton" onClick={onToggleLimitClick}>
        {shouldShowCollapsedList ? showMoreText : showLessText}
      </button> :
      null
  );

  return {
    itemsToShow: shouldShowCollapsedList ? items.slice(0, limit) : items,
    renderShowMoreButton,
  };
};
